


import Cctv from "../Pages/Cctv/Cctv";









import ParentOrientationVideos from "../Pages/ParentOrientationVideos/ParentOrientationVideos";
import PhotoGallery from "../Pages/PhotoGallery/PhotoGallery";


import TakeABreak from "../Pages/Support/TakeABreak/TakeABreak";
import ShiftCenter from "../Pages/Support/ShiftCenter/ShiftCenter";
import ChangeProgram from "../Pages/Support/ChangeProgram/ChangeProgram";

import Transport from "../Pages/Support/Transport/Transport";
import WithdrawChild from "../Pages/Support/WithdrawChild/WithdrawChild";



import RaiseTicket from "../Pages/Support/RaiseTicket/RaiseTicket";
import FeeCertificate from "../Pages/Support/Finanace/components/FeeCertificate";


import EarlyResume from "../Pages/Support/TakeABreak/EarlyResume";
import ExtendPause from "../Pages/Support/TakeABreak/ExtendPause";
import ExtendedDaycare from "../Pages/Support/ExtendedDaycare";






import Activity from "../Pages/OutdoorActivity/Activity";
import Conversation1 from "../Pages/Conversation/Conversation";

import ChildTimeline from "../Pages/ChildTimeline/ChildTimeline";



import Growth1 from "../Pages/Growth/Growth";

import ShareFeeCertificate1 from "../Pages/Support/Finanace/components/ShareFeeCertificate";

import Attendance from "../Pages/Attendance/Attendance";
import FoodMenuMobile from "../Pages/FoodMenu/FoodMenu1";
import MyCenterMobile from "../Pages/MyCenter/MyCenter";
import NewsMobile from "../Pages/Newsroom/News";


import HolidayCalender from "../Pages/HolidayCalender/HolidayCalender";
import MobileBlogs from "../Pages/Blogs/Blogs";
import ActivityCalendar from "../Pages/ActivityCalender/ActivityCalendar";
import Profile from "../Pages/Myprofile/profile";
import Notification from "../Pages/Notification/Notification";

import Finance from "../Pages/Support/Finanace/Finance";
import NonSatisfaction from "../Pages/Support/Finanace/components/NonSatisfaction";

import Support from "../Pages/Support/Support"
import PastRequest1 from "../Pages/Support/pastRequest/PastPast";




export const LoggedInRoutes = [

    {
        path: "/blogs", component: MobileBlogs,
    },
    {
        path: "/timeline", component: ChildTimeline,
    },
    {
        path: "/notification", component: Notification,
    },
    {
        path: "/activityCalendar", component: ActivityCalendar,
    },
    {
        path: "/myProfile", component: Profile,
    },
    {
        path: "/holidayCalendar", component: HolidayCalender,
    },
    {
        path: "/cctv", component: Cctv,
    }
    ,
    {
        path: "/center", component: MyCenterMobile,

    },
    {
        path: "/chat", component: Conversation1,
    },
    {
        path: "/foodMenu", component: FoodMenuMobile,
    }
    ,
    {
        path: "/growth", component: Growth1,
    }
    ,
    {
        path: "/outdoorActivity", component: Activity,
    },
    {
        path: "/photoGallery", component: PhotoGallery,
    },
    {
        path: "/support", component: Support,
    }, {
        path: "/parentVideo", component: ParentOrientationVideos,
    }, {
        path: "/newsRoom", component: NewsMobile,
    },
    {
        path: "Pause", component: TakeABreak
    },
    {
        path: "ShiftCentre", component: ShiftCenter
    },
    {
        path: "ChangeProgram", component: ChangeProgram
    },
    {
        path: "Finance", component: Finance
    },
    {
        path: "Transport", component: Transport
    },
    {
        path: "WithrawChild", component: WithdrawChild
    },
    {
        path: "PastRequestTab", component: PastRequest1
    }, {
        path: "raiseAnIssue", component: RaiseTicket
    }, {
        path: "feeCertificate", component: FeeCertificate
    }, {
        path: "nonSatisfaction", component: NonSatisfaction
    },
    {
        path: "shareFeeCerticate", component: ShareFeeCertificate1
    }

    , {
        path: "earlyResume", component: EarlyResume
    }
    , {
        path: "extendPause", component: ExtendPause
    }
    , {
        path: "extendedDaycare", component: ExtendedDaycare
    },
    {
        path: "attendance", component: Attendance
    },

    //New Routes

    // {
    //     path: "food-menu", component: <FoodMenuMobile />
    // },
    // {
    //     path: "outdoor-activity", component: <Activity />
    // },
    // {
    //     path: "mycenter", component: <MyCenterMobile />
    // },
    // {
    //     path: "activity-calendar", component: <ActivityCalendar1 />
    // },
    // {
    //     path: "verify", component: <LoginVerify1 />
    // }, {
    //     path: "convo", component: <Conversation1 />
    // }, {
    //     path: "profile", component: <Profile />
    // },
    // {
    //     path: "child-timeline", component: <ChildTimeline1 />
    // }, {
    //     path: "support1", component: < Support1 />
    // }, {
    //     path: "request", component: < PastRequest1 />
    // },
    // {
    //     path: "growth-new", component: < Growth1 />
    // },
    // {
    //     path: "news", component: < NewsMobile />
    // },
    // {
    //     path: "shareCertificate", component: < ShareFeeCertificate1 />
    // },
    // {
    //     path: "finance1", component: < Finance1 />
    // },

    // {
    //     path: "notification-mobile", component: < NotificationMobile />
    // },


]